!((document, Drupal, $) => {
  'use strict';

  function loadDropdownValue() {
    $('.form-dropdown-list').each(function() {
      let val = $(this)
        .find('.dropdown-item.selected')
        .text();

      $(this)
        .siblings('.dropdown-toggle')
        .html(val);
    });
  }

  function selectDropdownValue(e, that) {
    // Reset class
    that
      .closest('.form-dropdown-list')
      .find('.dropdown-item')
      .removeClass('selected');

    // Add selected
    that.addClass('selected');

    // Update button to show selected value
    let toggleButton = that
      .closest('.form-dropdown-list')
      .siblings('.dropdown-toggle');

    let selectedValue = e.target.hash;
    let hiddenInput = toggleButton
      .closest('.form-group.dropdown')
      .find('.form-control.hide')
      .first();

    hiddenInput.attr('value', selectedValue.replace('#', ''));
    hiddenInput.change();
    toggleButton.html(that.text());
  }

  loadDropdownValue();

  $('.form-dropdown-list .dropdown-item').on('click', function(e) {
    selectDropdownValue(e, $(this));
    e.preventDefault();
  });

  // Select area of interest dropdown based on query parameter in Contact Us form.
  if ($('body').hasClass('page-node-type-contact')) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const areaOfInterest = urlParams.get('area');

    if (areaOfInterest) {
      $('.form-dropdown-list li a').each(function() {
        if (areaOfInterest === $(this).text()) {
          $(this).click();
        }
      });
    }

  }
})(document, Drupal, jQuery);
